<template>
  <div class="batch-search search-box">
    <!-- 筛选条件 -->
    <div class="search-block border-bottom-divide">
      <span class="label search-label">筛选条件</span>
      <span class="label keyword-label">品牌</span>
      <el-select
          class="select-input"
          v-model="searchObj.brandCode"
          value-key="id"
          placeholder="不限"
          :disabled="from === 'IndoorUnitOthers'"
          @change="(v) => selectSeries(v)"
      >
        <el-option label="不限" value="" />
        <el-option
            v-for="v in brands"
            :key="v.brandCode"
            :label="v.brandName"
            :value="v.brandCode"
        />
      </el-select>
      <span class="label keyword-label">结构形式</span>
      <el-select
          class="select-input"
          style="width: 120px"
          v-model="searchObj.structuresCode"
          value-key="id"
          placeholder="请选择"
          :disabled="from === 'IndoorUnitOthers'"
          @change="(v) => selectStructures(v)"
      >
        <el-option
            v-for="(v, i) in structures"
            :key="i"
            :label="v.name"
            :value="v.code"
        />
      </el-select>
      <span class="label keyword-label">单台承担面积</span>
      <el-input
          class="narrow"
          ref="singleUnitResponsibilityArea"
          @blur="singleUnitChange"
          :disabled="from === 'IndoorUnitOthers'"
          v-model="searchObj.singleUnitResponsibilityArea"
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
      >
        <template #append>m²</template>
      </el-input>
    </div>
    <!-- 校核设置 -->
    <div class="search-block border-bottom-divide">
      <span class="label search-label">校核设置</span>
      <div class="label">
        <el-checkbox-group class="keyword-label" v-model="searchObj.validChecked" @change="changeTracksCondition">
          <el-checkbox v-for="(item, index) in validList" :key="index" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IndoorUnitSearch',
  props: {
    initValue: {
      type: Object,
      default() {
        return {
          brandName: '',
          brandCode: '',
          structuresName: '',
          structuresCode: '',
          singleUnitResponsibilityArea: '20',
          validChecked: [1],
        }
      }
    },
    from: {
      type: String,
      default: 'IndoorUnit',
    },
  },
  data() {
    return {
      searchObj: this.initValue,
      g_c_default_condition: true,
      validList: [
        {
          id: 1,
          name: '制冷量',
          code: 'P000094',
        },
        {
          id: 2,
          name: '制热量',
          code: 'P000095',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      brands: 'list/brands',
      aggProperties: 'fanList/aggProperties',
    }),
    // 结构形式选项
    structures() {
      const propertyObj = this.aggProperties.find((item) => item.name === '结构形式') || {}
      const valueArr = propertyObj.values || []
      const allOpts = ['风管式', '嵌入式-单面出风', '嵌入式-两面出风', '嵌入式-四面出风']
      const options = []
      allOpts.forEach((opt) => {
        const v = valueArr.find((it) => it.name === opt)
        if (v) {
          options.push(v)
        }
      })
      return options
    },
  },
  watch: {
    initValue(newVal) {
      this.searchObj = newVal ? { ...newVal } : {}
    },
    structures: {
      handler(val) {
        if (this.searchObj.structuresCode) { return }
        const firstItem = val[0]
        this.searchObj.structuresName = firstItem ? firstItem.name : ''
        this.searchObj.structuresCode = firstItem ? firstItem.code : ''
      },
      immediate: true
    },
  },
  methods: {
    changeTracksCondition() {
      this.g_c_default_condition = false
    },
    // 品牌筛选
    selectSeries(code) {
      this.searchObj.brandCode = code
      const item = this.brands.find((item) => { return item.brandCode === code }) || {}
      this.searchObj.brandName = item.brandName
      this.g_c_default_condition = false
    },

    // 结构形式
    selectStructures(code) {
      const item = this.structures.find((i) => i.code === code) || {}
      this.searchObj.structuresName = item.name
      this.g_c_default_condition = false
    },

    // 单台承担面积
    singleUnitChange() {
      this.g_c_default_condition = false
      if (!this.searchObj.singleUnitResponsibilityArea) {
        this.$message({
          message: '单台承担面积不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.singleUnitResponsibilityArea.focus()
      }
    },

    // 获取搜索参数
    getSearchData() {
      // 参数组装
      const productProperties = [
        {
          code: 'P000092',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: 'V000067',
        }
      ]
      const validProperties = []
      const nonValidProperties = []
      if (this.searchObj.structuresCode) {
        productProperties.push({
          code: 'P000003',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: this.searchObj.structuresCode,
        })
      }
      // 组装校核参数
      this.validList.forEach((item) => {
        if (this.searchObj.validChecked.includes(item.id)) {
          validProperties.push({ code: item.code })
        } else {
          nonValidProperties.push({ code: item.code })
        }
      })
      return {
        searchData: this.searchObj,
        productProperties,
        validProperties,
        nonValidProperties,
        g_c_default_condition: this.g_c_default_condition,
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-block {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0;
  line-height: 24px;
  .label {
    height: 24px;
    line-height: 24px;
    margin-right: 6px;
  }
  .switch {
    margin: 4px 16px 4px 0;
  }
}
.search-unit{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-left: 0;
  &.after-line{
    position: relative;
    margin-right: 24px;
    &:after{
      content: '';
      height: 16px;
      width: 1px;
      background: #ccc;
      right: -12px;
      top: 4px;
    }
  }
}
.select-input {
  width: 108px;
}
.keyword-label {
  margin: 0 6px 0 16px;
}
.search-label {
  margin-right: 8px;
}
.narrow {
  width: 73px;
}
.valid-box{
  display: flex;
  flex-direction: row;
}
</style>
